import { createFileRoute } from "@tanstack/react-router";
import { RuleSetList } from "@/components/data-quality/rule-set-screens";
import { maskRuleSets } from "@/api/data-quality";

export const Route = createFileRoute("/_app/data-quality/pii/")({
  component: PiiList,
});

function PiiList() {
  return (
    <RuleSetList
      kind="mask"
      query={maskRuleSets.useList()}
      save={maskRuleSets.useSave()}
      detailPath="/data-quality/pii/$id"
      title="PII masking rule sets"
      emptyBody="Define reusable PII masking rules to reference from pipeline MASK steps."
    />
  );
}
